module.exports = __webpack_public_path__ + "static/media/tip4.a90c1d85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Confirmation/img/tips/tip4.jpg
// module id = 975
// module chunks = 0